<template>
  <div>
    <a-modal
      :class="{ 'dark-theme-modal': darkTheme }"
      :title="modalTitle"
      v-model="printModalVisible"
      okText="Générer"
      :okButtonProps="darkTheme ? { props: {ghost: true} } : null"
      cancelText="Annuler"
      :cancelButtonProps="darkTheme ? { props: {ghost: true} } : null"
      @ok="handleSubmit"
      @cancel="handleCancel">
      <a-spin :spinning="loading">
        <a-icon slot="indicator" type="loading" style="font-size: 48px" spin />
        <a-row type="flex">
          <a-col :span="6"></a-col>
          <a-col :span="12">
            <a-form :form="form">
              <a-form-item label="Plage :">
                <a-range-picker
                  :class="{ 'dark-theme-calendar': darkTheme }"
                  size="large"
                  v-decorator="[
                    'dateRange',
                    {
                      rules: [{ required: true, message: 'Veuillez entrer une plage' }]
                    }
                  ]"
                  :ranges="getDetailsRange()"
                  :format="dateFormat"
                  :placeholder="['De', 'À']" />
              </a-form-item>
              <a-form-item label="Tri :">
                <a-select
                  :class="{ 'dark-theme-select': darkTheme }"
                  size="large"
                  v-decorator="[
                    'sort',
                    {
                      rules: [{ required: true, message: 'Veuillez spécifier la méthode de tri' }],
                      initialValue: '1'
                    }
                  ]">
                  <a-select-option value="1">Chronologique</a-select-option>
                  <a-select-option value="0">Non chronologique</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Inclure les remarques des détails :">
                <a-switch
                  v-decorator="['includeComments', { rules: [{ required: true }], initialValue: false, valuePropName: 'checked'}]"
                  checkedChildren="Oui" unCheckedChildren="Non" />
              </a-form-item>
            </a-form>
          </a-col>
          <a-col :span="6"></a-col>
        </a-row>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'
import DateService from '../../services/date_service'

export default {
  name: 'PrintModal',
  props: {
    type: String,
    modalTitle: String,
    rangeType: String,
    loading: Boolean
  },
  data () {
    return {
      dateFormat: 'DD.MM.YYYY',
      form: this.$form.createForm(this)
    }
  },
  methods: {
    moment,
    ...mapActions({
      'togglePrintMyWorksModalVisible': 'modal/togglePrintMyWorksModalVisible',
      'togglePrintStudentWorksModalVisible': 'modal/togglePrintStudentWorksModalVisible',
      'togglePrintClassroomWorksModalVisible': 'modal/togglePrintClassroomWorksModalVisible',
      'togglePrintDetailsModalVisible': 'modal/togglePrintDetailsModalVisible'
    }),
    handleSubmit (e) {
      this.form.validateFields((err, values) => {
        if (err) {
          return
        }
        this.$emit('clicked', values)
      })
    },
    handleCancel (e) {
      this.form.resetFields()
    },
    getDetailsRange () {
      if (this.rangeType === 'allDetails' && this.detailsData) {
        // Trier les détails dans un nouveau tableau
        let nonReactiveCopy = [...this.detailsData]
        if (nonReactiveCopy.length === 0) {
          return null
        }
        nonReactiveCopy.sort((a, b) => {
          return moment(a.dateDetail, 'DD.MM.YYYY') - moment(b.dateDetail, 'DD.MM.YYYY')
        })
        const from = DateService.formatDateToDatabaseFormat(nonReactiveCopy[0].dateDetail)
        const to = DateService.formatDateToDatabaseFormat(nonReactiveCopy[nonReactiveCopy.length - 1].dateDetail)
        return {
          'Tous les détails': [moment(from), moment(to)]
        }
      } else if (this.rangeType === 'thisWeek') {
        const from = moment().locale('fr').startOf('week')
        const to = moment().locale('fr').endOf('week').subtract(2, 'days')
        return {
          'Cette semaine': [moment(from.format('YYYY-MM-DD')), moment(to.format('YYYY-MM-DD'))]
        }
      }
      return null
    }
  },
  computed: {
    // v-model va automatiquement essayer de set printModalVisible lors de la fermeture de la modale. On crée donc
    // une computed property en lui indiquant quelle state il doit modifier suivant le type de la modale
    printModalVisible: {
      get () {
        if (this.type === 'my-works') return this.$store.state.modal.printMyWorksModalVisible
        if (this.type === 'students-works') return this.$store.state.modal.printStudentsWorksModalVisible
        if (this.type === 'classroom-works') return this.$store.state.modal.printClassroomWorksModalVisible
        if (this.type === 'details') return this.$store.state.modal.printDetailsModalVisible
        return 'default'
      },
      set (value) {
        if (this.type === 'my-works') this.togglePrintMyWorksModalVisible()
        if (this.type === 'students-works') this.togglePrintStudentWorksModalVisible()
        if (this.type === 'classroom-works') return this.togglePrintClassroomWorksModalVisible()
        if (this.type === 'details') this.togglePrintDetailsModalVisible()
      }
    },
    ...mapState({
      darkTheme: state => state.darkTheme,
      detailsData: state => state.detail.detailsData
    })
  }
}
</script>

<style scoped lang="scss">
// Modal
.add-work-date-input{
  width: 100%;
}
</style>
